<template>
	<div v-if="user" class="app-avatar" :style="{ 'font-size': size / 2 + 'px' }">
		<v-avatar :size="size" :color="colorAvatar">
			<img :src="avatarSrc" v-if="avatarSrc" />
			<div v-else>
				{{ letter }}
			</div>
		</v-avatar>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import AppAvatarService from './app-avatar-service';

export default {
	name: 'AppAvatar',
	props: {
		size: { type: Number, default: 40 },
		shorten: { type: Boolean, default: false },
	},
	computed: {
		...mapGetters(['user']),
		colorAvatar() {
			return '#781DA2';
		},
		letter() {
			return AppAvatarService.getAvatarLetter(this.user, this.shorten);
		},
		avatarSrc() {
			return AppAvatarService.getAvatarSrc(this.user.profile);
		},
	},
};
</script>

<style scoped lang="scss">
.app-avatar {
	color: white;
	font-weight: 300;
	user-select: none;
}
</style>
